import { has } from "../../../../utils/menu-context";
import store from "../../../../store";

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (store.state?.resource?.auth?.info?.user?.refOfficerLv) {
                return false;
            }
            if ([undefined, "draft", "reEdit"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
        canArchive: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canArchive" }) || record.isActive === false) return false;
            if (["draft"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
        canDelete: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canDelete" }) || record.isActive === false) return false;
            if (["draft"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        }
    };
};

export const createConditionForm = (/* { dataKey } */) => {
    //const prefix = dataKey ? `${dataKey}.` : "";
    //const prefixRegExp = dataKey ? `${dataKey}\\.` : "";
    return [];
};

export const commonInputPropField = ({ disabledStatuses }) => ({ initialModel }) => {
    let enabled = undefined;
    if (disabledStatuses.includes(initialModel.refStatus?.key)) {
        enabled = false;
    }
    return { disabled: enabled !== undefined ? !enabled : undefined };
};
